// Contenido de las guías de ayuda (Rodeo y Asistencia).
// Cada paso: { icono, titulo, descripcion (string | string[]), imagen? }
// "imagen" es el nombre del archivo dentro de /public/ayuda/.
// Si la imagen no existe, no se muestra (el texto sí).

export const AYUDA_RODEO = [
  {
    icono: '📊',
    titulo: 'Resumen del rodeo',
    descripcion: 'En la parte de arriba ves de un vistazo cuántos animales tenés Activos, Vendidos, Muertos y el Total. Se actualiza solo cada vez que registrás o modificás un animal.',
    imagen: 'rodeo-stats.png',
  },
  {
    icono: '🔎',
    titulo: 'Buscar y filtrar animales',
    descripcion: [
      'Escribí en los filtros para encontrar animales por Caravana, Nombre, Raza, Color o Clasificación.',
      'Elegí Sexo o Estado en las listas desplegables.',
      'Los resultados se filtran al instante, sin apretar ningún botón.',
      '🧹 "Limpiar" borra todos los filtros de una vez.',
    ],
    imagen: 'rodeo-filtros.png',
  },
  {
    icono: '➕',
    titulo: 'Registrar un animal nuevo',
    descripcion: [
      'Tocá el botón verde "+ Nuevo Animal".',
      'Obligatorios: Caravana, Sexo y Color de caravana (marcados con *).',
      'Para vincular Madre o Padre: escribí su caravana y tocá la lupa 🔍.',
      'Tocá "✓ Registrar Animal" para guardar.',
    ],
    imagen: 'rodeo-nuevo.png',
  },
  {
    icono: '📋',
    titulo: 'Ver la ficha de un animal',
    descripcion: [
      'En la fila del animal tocá "Ver Ficha".',
      'Arriba tenés las pestañas: Datos, ⚖️ Peso, 💉 Vacunas, 🐮 Crías y 🐄 Inseminación.',
      'Desde cada pestaña agregás, editás o borrás registros de ese animal.',
    ],
    imagen: 'rodeo-ficha.png',
  },
  {
    icono: '📥',
    titulo: 'Exportar a Excel',
    descripcion: 'El botón "📥 Exportar Excel" descarga una planilla con todos los animales que estés viendo según los filtros activos. Ideal para imprimir o respaldar.',
    imagen: 'rodeo-excel.png',
  },
  {
    icono: '⏭️',
    titulo: 'Moverte entre páginas',
    descripcion: 'Cuando hay muchos animales, abajo de la tabla aparecen "← Anterior" y "Siguiente →" para recorrer todas las páginas.',
  },
];

export const AYUDA_ASISTENCIA = [
  {
    icono: '🆕',
    titulo: 'Crear una asistencia',
    descripcion: [
      'Tocá "+ Nueva Asistencia".',
      'Elegí la Fecha y el Tipo: Vacunación, Antiaftosa, Control, Inseminación u Otros.',
      'Tocá "Crear y Comenzar" y ya podés empezar a contar.',
    ],
    imagen: 'asis-nueva.png',
  },
  {
    icono: '🏷️',
    titulo: 'Contar los animales presentes',
    descripcion: [
      'Escribí el número de caravana y tocá "Buscar" (o Enter).',
      'El animal se suma a la lista y el contador "Total presentes" sube.',
      'Si te equivocaste, tocá la ✕ roja para sacarlo de la lista.',
    ],
    imagen: 'asis-conteo.png',
  },
  {
    icono: '📊',
    titulo: 'Comparar con el rodeo',
    descripcion: [
      'Tocá "📊 Comparar con Rodeo".',
      'Ves quiénes están ✅ Presentes y quiénes ❌ Ausentes respecto al rodeo activo.',
      'Podés filtrar para ver solo presentes o solo ausentes.',
    ],
    imagen: 'asis-comparar.png',
  },
  {
    icono: '🔒',
    titulo: 'Cerrar y reabrir',
    descripcion: [
      'Cuando terminaste el conteo, tocá "🔒 Cerrar Asistencia".',
      'Recién con la asistencia cerrada aparecen los botones de acciones masivas.',
      'Si necesitás corregir algo, "🔓 Reabrir" la vuelve a habilitar.',
    ],
    imagen: 'asis-cerrar.png',
  },
  {
    icono: '💉',
    titulo: 'Vacunar a todos (masivo)',
    descripcion: [
      'Con la asistencia cerrada, tocá "💉 Vacunar Rodeo".',
      'Completá los datos de la vacuna (nombre, fecha, etc.).',
      'La vacuna se registra de una sola vez en TODOS los animales presentes.',
    ],
    imagen: 'asis-vacunar.png',
  },
  {
    icono: '🐄',
    titulo: 'Inseminar a todos (masivo)',
    descripcion: [
      'Con la asistencia cerrada, tocá "🐄 Inseminación".',
      'Elegí la fecha y, si querés, agregá una observación.',
      'La inseminación se registra de una vez en TODOS los animales presentes.',
    ],
    imagen: 'asis-inseminar.png',
  },
  {
    icono: '🖨️',
    titulo: 'Reporte y exportación',
    descripcion: [
      'Tocá "🖨️ Reporte Final" para ver el resumen: total, presentes, ausentes y % de cobertura.',
      'Desde ahí exportás a "📥 Excel" o "📄 PDF" para imprimir o guardar.',
    ],
    imagen: 'asis-reporte.png',
  },
];
